import React from 'react'

export declare namespace NUseComponentRerender {
  export interface IResult {
    rerender: TRerender
  }

  export type TRerender = () => void
}

export const useComponentRerender = (): NUseComponentRerender.IResult => {
  const renderCount = React.useRef<number>(0)
  const [, setRenderId] = React.useState<number>(renderCount.current)

  const rerender: NUseComponentRerender.TRerender = () => {
    renderCount.current = renderCount.current + 1
    setRenderId(renderCount.current)
  }

  return { rerender }
}
